const buttonList = [
    {
        type: 'text',
        class: 'bigData-btn-ltc-add',
        icon: 'el-icon-circle-plus-outline',
        label: '新增',
        size: 'small',
        event: 'add',
        ifHas: '07080010'
    },
    {
        type: 'text',
        class: 'bigData-btn-ltc-save',
        icon: 'el-icon-circle-check',
        label: '保存',
        size: 'small',
        event: 'save',
        loading: false,
        ifHas: '07080010'
    },
    {
        type: 'text',
        class: 'bigData-btn-ltc-save',
        icon: 'el-icon-circle-check',
        label: '导出',
        size: 'small',
        event: 'export',
        loading: false,
        ifHas: '07080011'
    },
    {
        type: 'text',
        class: 'bigData-btn-ltc-save',
        icon: 'el-icon-circle-check',
        label: '导入',
        size: 'small',
        event: 'upload',
        loading: false,
        ifHas: '07080012'
    },
    {
        type: 'text',
        class: 'bigData-btn-ltc-delete',
        icon: 'el-icon-delete',
        label: '删除',
        size: 'small',
        event: 'delete',
        loading: false,
        ifHas: '07080013'
    }
];

const config = {
    configuration: true,
    buttonList: buttonList,
    table:
    {
        selectBtn: true,
        tableCut: true,
        clickModify: false,
        height: 'calc(30vh)',
        leftOperation: true,
        columns: [],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'mini',
                event: 'edit'
            }
        ],
        leftWidth: 60
    },
    page: {
        // layout: 'total, sizes, prev, pager, next, jumper',
        layout: 'total,sizes,prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 100, 500]
    }
};

export const columnMap = {
    // 货物运输服务
    'CBS': [
        {
            label: '项目名称',
            prop: 'projectName',
            width: '200',
            'type': 'advance',
            mustFill: true,
            require: true
        },
        {
            label: '单位',
            prop: 'unit',
            width: '110',
            mustFill: false,
            require: true
        },
        {
            label: '数量',
            prop: 'quantity',
            width: '150',
            mustFill: false,
            require: true
        },
        {

            label: '单价（含税）',
            prop: 'unitPrice',
            width: '120',
            mustFill: false,
            require: true,
            verify: /^\d+(\.\d+)?$/
        },
        {
            label: '金额（含税）',
            prop: 'amt',
            width: '120',
            mustFill: true,
            require: true,
            verify: /^(-?\d+(\.\d+)?)$/

        },
        {
            label: '税率',
            prop: 'taxRate',
            width: '120',
            mustFill: true,
            require: true,
            disabled: true,
            placeholder: '请输入值为0-1的小数',
            verify: /^(-?\d+(\.\d+)?)$/

        },
        {
            label: '税额',
            prop: 'taxAmt',
            width: '120',
            mustFill: true,
            require: true,
            verify: /^(-?\d+(\.\d+)?)$/

        },
        {
            label: '不含税金额',
            prop: 'fee',
            width: '120',
            mustFill: true,
            require: true,
            verify: /^(-?\d+(\.\d+)?)$/

        }
    ],
    // 不动产经营租赁服务
    'REBLS': [
        {
            label: '项目名称',
            prop: 'projectName',
            width: '200',
            'type': 'advance',
            mustFill: true,
            require: true
        },
        {
            label: '产权证书/不动产权证号',
            prop: 'assetCertificate',
            width: '150',
            mustFill: true,
            require: true
        },
        {
            label: '面积单位',
            prop: 'areaUnit',
            type: 'select',
            popperAppendToBody: true,
            optionNum: 'SYS_BMS_AREA_UNIT',
            width: '110',
            mustFill: true,
            require: true
        },
        {
            label: '数量',
            prop: 'quantity',
            width: '120',
            mustFill: false,
            require: true
        },
        {
            label: '单价（含税）',
            prop: 'unitPrice',
            width: '120',
            mustFill: true,
            require: true,
            verify: /^(-?\d+(\.\d+)?)$/
        },
        {
            label: '金额（含税）',
            prop: 'amt',
            width: '120',
            mustFill: true,
            require: true,
            verify: /^(-?\d+(\.\d+)?)$/

        },
        {
            label: '税率/征收率',
            prop: 'taxRate',
            width: '120',
            mustFill: true,
            require: true,
            disabled: true,
            verify: /^(-?\d+(\.\d+)?)$/

        },
        {
            label: '税额',
            prop: 'taxAmt',
            width: '120',
            mustFill: true,
            require: true,
            verify: /^(-?\d+(\.\d+)?)$/

        },
        {
            label: '不含税金额',
            prop: 'fee',
            width: '120',
            mustFill: true,
            require: true,
            verify: /^(-?\d+(\.\d+)?)$/

        }
    ],
    // 非特异性的标签
    'NOLABLE': [
        {
            label: '项目名称',
            prop: 'projectName',
            'type': 'advance',
            width: '200',
            mustFill: true,
            require: true
        },
        {
            label: '规格型号',
            prop: 'standardModel',
            width: '150',
            mustFill: false,
            require: true
        },
        {
            label: '单位',
            prop: 'unit',
            width: '110',
            mustFill: false,
            require: true
        },
        {
            label: '数量',
            prop: 'quantity',
            width: '120',
            mustFill: false,
            require: true
        },
        {
            label: '单价（含税）',
            prop: 'unitPrice',
            width: '120',
            mustFill: false,
            require: true
        },
        {
            label: '金额（含税）',
            prop: 'amt',
            width: '120',
            mustFill: true,
            require: true,
            verify: /^(-?\d+(\.\d+)?)$/

        },
        {
            label: '税率/征收率',
            prop: 'taxRate',
            width: '120',
            mustFill: true,
            disabled: true,
            require: true
        },
        {
            label: '税额',
            prop: 'taxAmt',
            width: '120',
            mustFill: true,
            require: true
        },
        {
            label: '不含税金额',
            prop: 'fee',
            width: '120',
            mustFill: true,
            require: true,
            verify: /^(-?\d+(\.\d+)?)$/

        }
    ]
};

export const productDialogConfig = {
    title: '选择商品信息',
    tooltip: ['businessType', 'productName', 'taxName'],
    rowKeyProp: 'id',
    table: [
        {
            label: '业务类型',
            prop: 'businessTypeName',
            width: '150'
        },
        {
            label: '税率（%）',
            prop: 'taxRate',
            width: '150'

        },
        {
            label: '商品名称',
            prop: 'productName',
            width: '150'
        },
        {
            label: '税收分类名称',
            prop: 'taxName',
            width: '150'
        },
        {
            label: '税收编码简称',
            prop: 'taxShortName',
            width: '150'
        }
    ]
};

export const saveDataTemp = {
    'jobId': '',
    'projectName': '',
    'regProductId': '',
    'assetCertificate': '',
    'areaUnit': '',
    'standardModel': '',
    'unit': '',
    'quantity': '',
    'unitPrice': '',
    'amt': '',
    'fee': '',
    'taxRate': '',
    'taxAmt': '',
    'recVer': '',
    'recStatus': '',
    'creator': '',
    'createTime': '',
    'modifier': '',
    'modifyTime': ''
};

export const showActionBar = (flag) => {
    config.buttonList = flag ? buttonList : false;
};

export const changeRequired = (data = [], props = [], isRequired = false) => data.forEach(el => props.includes(el.prop) && (el.mustFill = isRequired));

export default config;
